import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AuthzService } from '../../core/auth/authz.service';
import { AuthFacade } from '../../core/auth/auth.facade';
import { USER_META_STATE } from '../../core/auth/auth.interface';
import { Router } from '@angular/router';
// import {ROUTER_TOKENS} from "../../app.routes";
//Service
import { LoggingService } from '../../core/utils/logging.service';
// RxJS
import { tap } from 'rxjs';
// PrimeNG
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';

@Component({
  selector: 'app-success-new-user',
  imports: [ImageModule, ButtonModule, TranslocoModule, LanguageConfigComponent],
  template: `
    <div class="flex h-screen flex-column">
      <div class="flex flex-column h-full w-full justify-content-center align-items-center bg-landing">
        <div class="flex justify-content-end w-full p-3">
          <app-language-config></app-language-config>
        </div>
        <div class="flex flex-1 justify-content-center align-items-center">
          <div
            class="flex flex-1 flex-column gap-4 justify-content-center align-items-center border-round-2xl bg-white p-4 h-max"
            style="width: 420px; height:310px"
          >
            <p-image src="assets/icons/icon-success.png" alt="success" width="62px" />
            <p class="text-lg text-color font-semibold text-center">{{ 'success_new_user.header' | transloco }}</p>
            <p class="text-center text-xs text-bluegray-500 font-normal text-center px-4">
              {{ 'success_new_user.sub-header1' | transloco }}
              <br />
              {{ 'success_new_user.sub-header2' | transloco }}
            </p>
            <p-button class="flex" [label]="'success_new_user.button' | transloco" (click)="handleRedirect()" />
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class SuccessNewUserComponent implements OnInit {
  private readonly router = inject(Router);
  private authzService = inject(AuthzService);
  private readonly authFacade = inject(AuthFacade);
  private auth0 = inject(AuthService);
  private readonly loggingService = inject(LoggingService);

  ngOnInit() {
    this.loggingService.warn('🔥///[COMP-SuccessNewUser]///');
    // fetch token and update state
    this.authFacade.updateAuthState({ userState: USER_META_STATE.OWNER });
    this.authzService.getUserAuth0();
    this.forceFetchUserToken();
    this.loggingService.error(this.authFacade.isFirstLoadOnSuccessNewUser());
  }

  forceFetchUserToken() {
    if (this.authFacade.isFirstLoadOnSuccessNewUser()) {
      this.loggingService.warn('0️⃣###force fetching user token');
      this.authFacade.updatePageRenderState({
        isFirstLoadOnSuccessNewUser: false,
      });
      this.reloadPage();
    }
  }

  handleRedirect() {
    // this.authzService.getCurrentUser().pipe(
    //   tap(() => this.router.navigate([`/${ROUTER_TOKENS.CHOOSE_COMPANY}`]))
    // ).subscribe()
    // this.router.navigate([`/${ROUTER_TOKENS.CHOOSE_COMPANY}`])
    // this.authzService.getUserFromAuth0().subscribe()
    this.authzService
      .handleRedirectCallback()
      .pipe(
        tap((r) => this.loggingService.error('@@@@@@@@@@@@@@@@@', r)),
        tap(() => this.router.navigate(['/choose-company']))
      )
      .subscribe();
    // this.auth0.user$.pipe(
    //   tap(r => this.loggingService.error('@@@@@@@@@@@@@@@@@', r)),
    //   tap(() => this.router.navigate(['/choose-company']))
    // ).subscribe()
    // this.loggingService.log('IsAuthenticated:', this.auth0.isAuthenticated$.subscribe());
    // this.loggingService.log(this.auth0)
  }

  reloadPage() {
    this.loggingService.warn('1️⃣///[COMP-SuccessNewUser]///reload page');
    this.authzService
      .getUserFromAuth0()
      .pipe(tap(() => window.location.reload()))
      .subscribe();
  }
}
